module.exports = __webpack_public_path__ + "img/thais.9add7ead.jpeg";